import * as React from "react";
import { Datagrid, TextField, useListContext } from "react-admin";
import { CustomDateField } from "../../../../../Components/CustomDateField";
import { EnumField } from "../../../../../Components/EnumField";
import CreatedByField from "../../../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import Actions from "./PbhWaitingResponseActions";
import { getSecureRandom } from "../../../../../Helper/random";

export const PbhWaitingResponseDataGrid = ({
  setWaitingResponseTabVisible,
  sendAgainButtonClick,
  fileDetailOnClick,
  mainData,
  cancelButtonClick,
  commentHistoryOnClick,
  editButtonClick,
  ...props
}) => {
  const { total, loaded } = useListContext();
  React.useEffect(() => {
    if (loaded) {
      var isVisible = total > 0 ? true : false;
      setWaitingResponseTabVisible?.(isVisible);
    }
  }, [total]);
  return (
    <Datagrid {...props}>
      {
        <Actions
          key={getSecureRandom()}
          mainData={mainData}
          cancelButtonClick={cancelButtonClick}
          sendAgainButtonClick={sendAgainButtonClick}
          commentHistoryOnClick={commentHistoryOnClick}
          editButtonClick={editButtonClick}
          fileDetailOnClick={fileDetailOnClick}
        />
      }
      <TextField source="ttUserRemark" label="TT User Remark" />
      <TextField source="customerRemark" label="Customer Remark" />
      <EnumField label={"Requested Info"} enumName={"PbhRequestedInfoType"} source={"pbhRequestedInfoEnum"} />
      <EnumField label={"Status"} enumName={"WaitingResponseType"} source={"waitingResponseEnum"} />
      <CreatedByField label="Responded By" source="respondedBy" link={false} />
      <CustomDateField source="respondedDate" label={"Responded Date"} showTime={true} locales="en-GB" />
      <CreatedByField label="Created by" link={false} />
      <CustomDateField source="createdDate" label={"Created Date"} showTime={true} locales="en-GB" />
      <CreatedByField label="Cancelled by" source="cancelledBy" link={false} />
      <CustomDateField source="cancelledDate" label={"Cancelled Date"} showTime={true} locales="en-GB" />
      <CreatedByField label="Returned by" source="returnedBy" link={false} />
      <CustomDateField source="returnedDate" label={"Returned Date"} showTime={true} locales="en-GB" />
    </Datagrid>
  );
};

export default PbhWaitingResponseDataGrid;
